import { create } from 'zustand';
import _ from 'underscore';
import { Urls } from '../services/Urls';
import services from '../services/services';
import { callautopopulate } from '../services/callautopop';

const projectStore = create((set, get) => ({
    projectUserList: [],
    options: [],
    error: null,
    getProjectUserList: async (id, productCode) => {
        if (!id) return;

        set({ isLoading: true, error: null });
        const payload = {
            "project_id": id,
            "product_code": productCode || 1002,
        };

        try {
            const res = await services.getInvokeRemote('POST', Urls('GETPROJECTUSERLIST'), payload);
            const users = res?.body.data.project_User_List || [];
            if (!_.isEmpty(users)) {
                set({ projectUserList: users });
                return users;
            } else {
                set({ projectUserList: [] });
            }
        } catch (error) {
            console.error("Error fetching project users:", error);
        }
    },
    getFilterOptions: async (autopopulateKeys) => {
        const { options } = get();
        const isLoaded = autopopulateKeys.every(k => options?.[k.key]?.length);
        if (isLoaded) return;
        callautopopulate("user_info", ..._.pluck(autopopulateKeys, "key"))?.then(res => {
            let obj = {};
            autopopulateKeys?.forEach(item => {
                obj[item?.key] = res?.[item?.key]?.sort((a, b) => a?.[item?.optionLabel]?.toString()?.localeCompare(b?.[item?.optionLabel]?.toString()));
                if (item?.key === "project_leads") {
                    const leadsWithGroup = (res?.project_leads || []).map(lead => ({
                        ...lead,
                        group_id: _.findWhere(res?.users, { user_code: lead.user_code })?.group_id || null
                    }));
                    obj.project_leads = leadsWithGroup
                    const selectedLead = _.findWhere(leadsWithGroup, { user_code: res?.user_info?.[0]?.user_code });
                    const userRecord = _.find(res?.users, { user_code: res?.user_info?.[0]?.user_code });
                    const effectiveGroupId = res?.user_info?.[0]?.group_id || userRecord?.group_id;
                    const selectedUnit = userRecord?.group_name !== "SRK Exports" ? null : _.find(obj?.day_calendar_groups, { group_id: effectiveGroupId });
                    ((!_.isEmpty(selectedLead) && !_.isEqual(selectedLead, options?.selectedLead)) || (!_.isEmpty(selectedUnit) && !_.isEqual(selectedUnit, options?.selectedUnit))) && set((state) => ({ options: { ...state?.options, ...(selectedLead && { selectedLead }), ...(selectedUnit && { selectedUnit }) } }));
                } else if (item?.key === "precision_lead") {
                    const selectedLead = _.findWhere(res?.precision_lead, { user_code: res?.user_info?.[0]?.user_code });
                    !_.isEmpty(selectedLead) && set((state) => ({ options: { ...state?.options, ...{selectedLead} } }))
                }
            })
            set((state) => ({ options: { ...state?.options, ...obj, userInfo: res?.user_info[0], apiCall: true } }));
        })
    },
    resetModules: () => set({ projectUserList: [], options: [], error: null })
}));

export default projectStore;